interface LocalStorage {
  getItem: (item: string) => string | null
  setItem: (item: string, value: string) => boolean
  removeItem: (item: string) => boolean
}

const safeStorage: LocalStorage = {
  getItem: (item: string): string | null => {
    try {
      return localStorage.getItem(item)
    } catch (e) {
      return null
    }
  },
  setItem: (item: string, value: string) => {
    try {
      localStorage.setItem(item, value)
      return true
    } catch (e) {
      return false
    }
  },
  removeItem: (item: string): boolean => {
    try {
      localStorage.removeItem(item)
      return true
    } catch (e) {
      return false
    }
  },
}

export default safeStorage
